import { Component, OnInit, ViewChild } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { WebSiteService } from '../services/website-service';
import { ContactPageShowModel } from '../model/contact-page.model';
import { ContactFormRequestModel } from '../model/contact-form-request.model';
import { RecaptchaComponent } from 'angular-google-recaptcha';

@Component({
  selector: 'm-contact-page',
  templateUrl: './contact-page.component.html',
  styleUrls: [
    './contact-page.component.scss'
  ]
})
export class ContactPageComponent implements OnInit {
  contactUsData: ContactPageShowModel = {} as any;
  contactFormModel: ContactFormRequestModel = new ContactFormRequestModel();
  captchaIsValid = false;
  loading = false;
  @ViewChild(RecaptchaComponent) captchaComponent: RecaptchaComponent;

  constructor(
    private services: WebSiteService,
    private cd: ChangeDetectorRef) {
  }

  ngOnInit(): void {
    this.services.getContactUsPage().subscribe(result => {
      this.contactUsData = result.data;
      this.cd.detectChanges();
    });
  }

  contactFormSubmit(form, $event) {
    this.loading = true;
    $event.preventDefault();
    if (form.valid && this.captchaIsValid) {
      this.contactFormModel.captchaResponse = (this.captchaComponent as any).recaptchaAPI.getResponse();
      this.services.sendContactForm(this.contactFormModel).subscribe(data => {
        this.contactFormModel.message = '';
        this.loading = false;
        this.cd.detectChanges();
        (this.captchaComponent as any).recaptchaAPI.reset();
      }, (error) => {
        this.loading = false;
        this.cd.detectChanges();
        (this.captchaComponent as any).recaptchaAPI.reset();
      });

    }
  }
}
